import { StandardSectionExtractButton } from './StandardSectionExtractButton'
import { StandardSectionExtractDialog } from './StandardSectionExtractDialog'
import { StandardScopeExtractDialog } from './StandardScopeExtractDialog'
import type { StandardSectionExtractionState } from '../hooks/useStandardSectionExtraction'

type StandardSectionExtractControlsProps = {
  hasPdf: boolean
  extraction: StandardSectionExtractionState
}

export function StandardSectionExtractControls({
  hasPdf,
  extraction,
}: StandardSectionExtractControlsProps) {
  if (!hasPdf) {
    return null
  }

  const {
    section,
    openExtractDialog,
    extractDialogOpen,
    handleExtractDialogOpenChange,
  } = extraction

  const ExtractDialog =
    section === 'scope' ? StandardScopeExtractDialog : StandardSectionExtractDialog

  return (
    <>
      <StandardSectionExtractButton
        extraction={extraction}
        onClick={openExtractDialog}
        isExternalTrigger
      />
      <ExtractDialog
        open={extractDialogOpen}
        onOpenChange={handleExtractDialogOpenChange}
        extraction={extraction}
      />
    </>
  )
}
